// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WordpressWebsitesRouteImport } from './routes/wordpress-websites'
import { Route as WebsiteManagementRouteImport } from './routes/website-management'
import { Route as WebDesignRouteImport } from './routes/web-design'
import { Route as TermsAndConditionsRouteImport } from './routes/terms-and-conditions'
import { Route as SoftwareDevelopmentRouteImport } from './routes/software-development'
import { Route as SitemapRouteImport } from './routes/sitemap'
import { Route as ShopifyWebsitesRouteImport } from './routes/shopify-websites'
import { Route as ServicesRouteImport } from './routes/services'
import { Route as SeoRouteImport } from './routes/seo'
import { Route as ProjectsRouteImport } from './routes/projects'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as HostingRouteImport } from './routes/hosting'
import { Route as FaqsRouteImport } from './routes/faqs'
import { Route as CookiesRouteImport } from './routes/cookies'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as BlogRouteImport } from './routes/blog'
import { Route as BespokeAppDevelopmentRouteImport } from './routes/bespoke-app-development'
import { Route as AreasRouteImport } from './routes/areas'
import { Route as AboutRouteImport } from './routes/about'
import { Route as R404RouteImport } from './routes/404'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SeoIndexRouteImport } from './routes/seo.index'
import { Route as SeoTradesRouteImport } from './routes/seo.trades'
import { Route as SeoTechnicalSeoSupportRouteImport } from './routes/seo.technical-seo-support'
import { Route as SeoOrganicSeoServicesRouteImport } from './routes/seo.organic-seo-services'
import { Route as SeoLinkBuildingOutreachRouteImport } from './routes/seo.link-building-outreach'
import { Route as SeoBespokeSeoWebsiteAuditsRouteImport } from './routes/seo.bespoke-seo-website-audits'
import { Route as SeoLocationRouteImport } from './routes/seo.$location'
import { Route as ProjectsIndexRouteImport } from './routes/projects.index'
import { Route as ProjectsSlugRouteImport } from './routes/projects.$slug'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as AreasBarnsleyRouteImport } from './routes/areas.barnsley'
import { Route as SeoSectorsSectorRouteImport } from './routes/seo.sectors.$sector'
import { Route as SeoTradesIndexRouteImport } from './routes/seo.trades.index'
import { Route as SeoTradesPlumbersRouteImport } from './routes/seo.trades.plumbers'
import { Route as SeoTradesElectriciansRouteImport } from './routes/seo.trades.electricians'
import { Route as SeoTradesContractorsRouteImport } from './routes/seo.trades.contractors'
import { Route as SeoTradesBuildersRouteImport } from './routes/seo.trades.builders'
import { Route as SeoLocationTopicRouteImport } from './routes/seo.$location.$topic'

const WordpressWebsitesRoute = WordpressWebsitesRouteImport.update({
            id: '/wordpress-websites',path: '/wordpress-websites',getParentRoute: () => rootRouteImport
          })
const WebsiteManagementRoute = WebsiteManagementRouteImport.update({
            id: '/website-management',path: '/website-management',getParentRoute: () => rootRouteImport
          })
const WebDesignRoute = WebDesignRouteImport.update({
            id: '/web-design',path: '/web-design',getParentRoute: () => rootRouteImport
          })
const TermsAndConditionsRoute = TermsAndConditionsRouteImport.update({
            id: '/terms-and-conditions',path: '/terms-and-conditions',getParentRoute: () => rootRouteImport
          })
const SoftwareDevelopmentRoute = SoftwareDevelopmentRouteImport.update({
            id: '/software-development',path: '/software-development',getParentRoute: () => rootRouteImport
          })
const SitemapRoute = SitemapRouteImport.update({
            id: '/sitemap',path: '/sitemap',getParentRoute: () => rootRouteImport
          })
const ShopifyWebsitesRoute = ShopifyWebsitesRouteImport.update({
            id: '/shopify-websites',path: '/shopify-websites',getParentRoute: () => rootRouteImport
          })
const ServicesRoute = ServicesRouteImport.update({
            id: '/services',path: '/services',getParentRoute: () => rootRouteImport
          })
const SeoRoute = SeoRouteImport.update({
            id: '/seo',path: '/seo',getParentRoute: () => rootRouteImport
          })
const ProjectsRoute = ProjectsRouteImport.update({
            id: '/projects',path: '/projects',getParentRoute: () => rootRouteImport
          })
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => rootRouteImport
          })
const HostingRoute = HostingRouteImport.update({
            id: '/hosting',path: '/hosting',getParentRoute: () => rootRouteImport
          })
const FaqsRoute = FaqsRouteImport.update({
            id: '/faqs',path: '/faqs',getParentRoute: () => rootRouteImport
          })
const CookiesRoute = CookiesRouteImport.update({
            id: '/cookies',path: '/cookies',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const BlogRoute = BlogRouteImport.update({
            id: '/blog',path: '/blog',getParentRoute: () => rootRouteImport
          })
const BespokeAppDevelopmentRoute = BespokeAppDevelopmentRouteImport.update({
            id: '/bespoke-app-development',path: '/bespoke-app-development',getParentRoute: () => rootRouteImport
          })
const AreasRoute = AreasRouteImport.update({
            id: '/areas',path: '/areas',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const R404Route = R404RouteImport.update({
            id: '/404',path: '/404',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const SeoIndexRoute = SeoIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => SeoRoute
          })
const SeoTradesRoute = SeoTradesRouteImport.update({
            id: '/trades',path: '/trades',getParentRoute: () => SeoRoute
          })
const SeoTechnicalSeoSupportRoute = SeoTechnicalSeoSupportRouteImport.update({
            id: '/technical-seo-support',path: '/technical-seo-support',getParentRoute: () => SeoRoute
          })
const SeoOrganicSeoServicesRoute = SeoOrganicSeoServicesRouteImport.update({
            id: '/organic-seo-services',path: '/organic-seo-services',getParentRoute: () => SeoRoute
          })
const SeoLinkBuildingOutreachRoute = SeoLinkBuildingOutreachRouteImport.update({
            id: '/link-building-outreach',path: '/link-building-outreach',getParentRoute: () => SeoRoute
          })
const SeoBespokeSeoWebsiteAuditsRoute = SeoBespokeSeoWebsiteAuditsRouteImport.update({
            id: '/bespoke-seo-website-audits',path: '/bespoke-seo-website-audits',getParentRoute: () => SeoRoute
          })
const SeoLocationRoute = SeoLocationRouteImport.update({
            id: '/$location',path: '/$location',getParentRoute: () => SeoRoute
          })
const ProjectsIndexRoute = ProjectsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ProjectsRoute
          })
const ProjectsSlugRoute = ProjectsSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => ProjectsRoute
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => BlogRoute
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => BlogRoute
          })
const AreasBarnsleyRoute = AreasBarnsleyRouteImport.update({
            id: '/barnsley',path: '/barnsley',getParentRoute: () => AreasRoute
          })
const SeoSectorsSectorRoute = SeoSectorsSectorRouteImport.update({
            id: '/sectors/$sector',path: '/sectors/$sector',getParentRoute: () => SeoRoute
          })
const SeoTradesIndexRoute = SeoTradesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => SeoTradesRoute
          })
const SeoTradesPlumbersRoute = SeoTradesPlumbersRouteImport.update({
            id: '/plumbers',path: '/plumbers',getParentRoute: () => SeoTradesRoute
          })
const SeoTradesElectriciansRoute = SeoTradesElectriciansRouteImport.update({
            id: '/electricians',path: '/electricians',getParentRoute: () => SeoTradesRoute
          })
const SeoTradesContractorsRoute = SeoTradesContractorsRouteImport.update({
            id: '/contractors',path: '/contractors',getParentRoute: () => SeoTradesRoute
          })
const SeoTradesBuildersRoute = SeoTradesBuildersRouteImport.update({
            id: '/builders',path: '/builders',getParentRoute: () => SeoTradesRoute
          })
const SeoLocationTopicRoute = SeoLocationTopicRouteImport.update({
            id: '/$topic',path: '/$topic',getParentRoute: () => SeoLocationRoute
          })





const AreasRouteChildren = {
  AreasBarnsleyRoute: AreasBarnsleyRoute
}

const AreasRouteWithChildren = AreasRoute._addFileChildren(AreasRouteChildren)




const BlogRouteChildren = {
  BlogSlugRoute: BlogSlugRoute,BlogIndexRoute: BlogIndexRoute
}

const BlogRouteWithChildren = BlogRoute._addFileChildren(BlogRouteChildren)




const ProjectsRouteChildren = {
  ProjectsSlugRoute: ProjectsSlugRoute,ProjectsIndexRoute: ProjectsIndexRoute
}

const ProjectsRouteWithChildren = ProjectsRoute._addFileChildren(ProjectsRouteChildren)




const SeoLocationRouteChildren = {
  SeoLocationTopicRoute: SeoLocationTopicRoute
}

const SeoLocationRouteWithChildren = SeoLocationRoute._addFileChildren(SeoLocationRouteChildren)




const SeoTradesRouteChildren = {
  SeoTradesBuildersRoute: SeoTradesBuildersRoute,SeoTradesContractorsRoute: SeoTradesContractorsRoute,SeoTradesElectriciansRoute: SeoTradesElectriciansRoute,SeoTradesPlumbersRoute: SeoTradesPlumbersRoute,SeoTradesIndexRoute: SeoTradesIndexRoute
}

const SeoTradesRouteWithChildren = SeoTradesRoute._addFileChildren(SeoTradesRouteChildren)



const SeoRouteChildren = {
  SeoLocationRoute: SeoLocationRouteWithChildren,SeoBespokeSeoWebsiteAuditsRoute: SeoBespokeSeoWebsiteAuditsRoute,SeoLinkBuildingOutreachRoute: SeoLinkBuildingOutreachRoute,SeoOrganicSeoServicesRoute: SeoOrganicSeoServicesRoute,SeoTechnicalSeoSupportRoute: SeoTechnicalSeoSupportRoute,SeoTradesRoute: SeoTradesRouteWithChildren,SeoIndexRoute: SeoIndexRoute,SeoSectorsSectorRoute: SeoSectorsSectorRoute
}

const SeoRouteWithChildren = SeoRoute._addFileChildren(SeoRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,R404Route: R404Route,AboutRoute: AboutRoute,AreasRoute: AreasRouteWithChildren,BespokeAppDevelopmentRoute: BespokeAppDevelopmentRoute,BlogRoute: BlogRouteWithChildren,ContactRoute: ContactRoute,CookiesRoute: CookiesRoute,FaqsRoute: FaqsRoute,HostingRoute: HostingRoute,PrivacyPolicyRoute: PrivacyPolicyRoute,ProjectsRoute: ProjectsRouteWithChildren,SeoRoute: SeoRouteWithChildren,ServicesRoute: ServicesRoute,ShopifyWebsitesRoute: ShopifyWebsitesRoute,SitemapRoute: SitemapRoute,SoftwareDevelopmentRoute: SoftwareDevelopmentRoute,TermsAndConditionsRoute: TermsAndConditionsRoute,WebDesignRoute: WebDesignRoute,WebsiteManagementRoute: WebsiteManagementRoute,WordpressWebsitesRoute: WordpressWebsitesRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)